import * as s from "./website-black-search.scss";
import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import {WebsiteBlackWordsStatsComponent} from "../words/stats/WebsiteBlackWordsStatsComponent";
import {WebsiteBlackSearchCasesComponent} from "./cases/WebsiteBlackSearchCasesComponent";
import {IWebsiteBlackSearch} from "./types/IWebsiteBlackSearch";

export class WebsiteBlackSearchComponent extends Component {
    constructor(p: IWebsiteBlackSearch) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackSearch}">
                <div class="${s.title}">
                    ${p.title}
                </div>
                <div class="${s.search}">
                    <div class="${s.google}"></div>
                    <div class="${s.input}">
                        <div class="${s.icon}"></div>
                        ${p.keyword}
                    </div>
                </div>
                <div class="${s.stats}">
                    ${this.draw(new WebsiteBlackWordsStatsComponent(p.stats))}
                </div>
                ${this.draw(new WebsiteBlackSearchCasesComponent(p.cases))}
            </div>
        `;
    }
}